const NewFileIcon = () => {
    return (
        <img
            style={{ width: '100%', height: '100%' }}
            src="/images/add-file-icon.svg"
            alt="Document Icon"
        />
    );
};

export default NewFileIcon;
